import React, { memo } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import BreadcrumbArrow from '../../components/Icons/BreadcrumbArrow';
import Span from '../Span';

export interface BreadcrumbItemType {
  id: number;
  text: string;
  link: string;
}

export interface LinkTextType extends BreadcrumbItemType {
  className?: string;
  separator?: JSX.Element | string;
  image?: string;
}

export interface BreadcrumbProps {
  className?: string;
  dataSet: BreadcrumbItemType[];
  dataTestId?: string;
  separator?: JSX.Element | string;
}

const LinkText = (props: LinkTextType) => (
  <>
    {props.separator && props.separator}
    <Link href={props.link} key={props.id} className={props.className}>
      {props.text}
    </Link>
  </>
);

const getBreadcrumbLinks = (props: BreadcrumbProps) => {
  const { dataSet, separator = <BreadcrumbArrow className="inline-block" /> } = props;

  return dataSet.map((breadcrumb, index) => {
    if (!breadcrumb.text) return null;
    if (!index) return <LinkText {...breadcrumb} className="capitalize" key={breadcrumb.id} />;

    if (index === dataSet.length - 1) {
      return (
        <React.Fragment key={breadcrumb.id}>
          {separator}
          <Span className="capitalize text-cti-tertiary">{breadcrumb.text}</Span>
        </React.Fragment>
      );
    }
    return (
      <LinkText {...breadcrumb} className="capitalize" separator={separator} key={breadcrumb.id} />
    );
  });
};

const Breadcrumb = ({ dataSet, className, dataTestId }: BreadcrumbProps) => {
  if (!dataSet || dataSet.length === 0) return null;
  return (
    <nav
      data-testid={dataTestId}
      className={classNames(
        'text-cti-secondary text-body-sm md:text-body-sm-desktop truncate text-left',
        className,
      )}
      style={{ direction: 'rtl' }}
    >
      {getBreadcrumbLinks({ dataSet })}
    </nav>
  );
};

export default memo(Breadcrumb);
